const EmailIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 16" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 0V16H0V0H20ZM2.62884 2L10 7.733L17.3712 2H2.62884ZM18 4.04464V14H2V4.04464L10 10.2669L18 4.04464Z" fill="black"/>
</svg>`;
export default EmailIcon;
